const RETURN_PATH_KEY = "autopto-card-setup-return";
const PAYMENT_METHOD_KEY = "card-setup-payment-method";

// Storage may be unavailable (private mode): Stripe then brings the user
// back to billing, as for any card.
export const saveCardSetupReturnPath = (path: string) => {
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, path);
  } catch {
    // Billing it is.
  }
};

export const clearCardSetupReturnPath = () => {
  try {
    sessionStorage.removeItem(RETURN_PATH_KEY);
    sessionStorage.removeItem(PAYMENT_METHOD_KEY);
  } catch {
    // Nothing was kept.
  }
};

/**
 * Where to land once Stripe has saved the card: the page the card dialog
 * was opened on. An app path only, never another origin.
 */
export const getCardSetupReturnPath = () => {
  try {
    const path = sessionStorage.getItem(RETURN_PATH_KEY);

    if (!path) return null;

    // Resolved the way the browser would ("/\host" leaves the origin too).
    const url = new URL(path, window.location.origin);

    // "/.//host" resolves to "//host" on this origin: navigating there
    // would leave it.
    return url.origin === window.location.origin &&
      !url.pathname.startsWith("//")
      ? `${url.pathname}${url.search}`
      : null;
  } catch {
    return null;
  }
};

/**
 * The payment method the team had when the card dialog opened (see
 * paymentMethodSignature), null for none: back from Stripe, billing is
 * rechecked until it changes.
 */
export const saveCardSetupPaymentMethod = (signature: string | null) => {
  try {
    sessionStorage.setItem(PAYMENT_METHOD_KEY, JSON.stringify(signature));
  } catch {
    // Not watched then, as before.
  }
};

// Undefined when it wasn't kept (unknown, unlike null).
export const getCardSetupPaymentMethod = (): string | null | undefined => {
  try {
    const raw = sessionStorage.getItem(PAYMENT_METHOD_KEY);
    const signature: unknown = raw === null ? undefined : JSON.parse(raw);

    return typeof signature === "string" || signature === null
      ? signature
      : undefined;
  } catch {
    return undefined;
  }
};
